import React from 'react';
export const CTABanner = () => {
  return <section className="py-20 relative overflow-hidden" data-id="element-22">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-teal to-teal/80 z-0" style={{
      backgroundImage: `
            linear-gradient(to bottom right, #0b757a, #085c60),
            url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
          `
    }} data-id="element-23"></div>
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10" data-id="element-24">
        <div className="absolute top-10 left-10 w-40 h-40 rounded-full border-8 border-white/20" data-id="element-25"></div>
        <div className="absolute bottom-20 right-20 w-60 h-60 rounded-full border-8 border-white/10" data-id="element-26"></div>
        <div className="absolute top-1/2 right-1/3 w-20 h-20 rounded-full border-4 border-white/30" data-id="element-27"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-28">
        <div className="max-w-4xl mx-auto text-center" data-id="element-29">
          <h2 className="text-4xl md:text-5xl font-bold mb-10 text-white tracking-tight" data-id="element-30">
            Skills. Compliance. Growth. <br className="hidden md:block" data-id="element-31" />
            All in One Platform
          </h2>
          <div className="flex flex-col sm:flex-row justify-center gap-6" data-id="element-32">
            <a href="/courses" className="px-10 py-4 bg-white text-teal font-medium rounded-md hover:bg-gray-50 transition-all duration-300 shadow-xl transform hover:-translate-y-1" data-id="element-33">
              Browse Courses
            </a>
            <a href="/programs" className="px-10 py-4 bg-transparent text-white font-medium rounded-md border-2 border-white hover:bg-white/10 transition-all duration-300 transform hover:-translate-y-1" data-id="element-34">
              Explore Programs
            </a>
          </div>
        </div>
      </div>
    </section>;
};